// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import { updateBulkEditState } from 'redux/modules/bulkEdit/actions'
import getFilteredSegmentEndIds from 'redux/modules/bulkEdit/thunks/getFilteredSegmentEndIds'

const updateHighlighted = () => (dispatch, getState) => {
  const {
    bulkEdit,
    form,
  } = getState()

  const { bulkMode } = form[BULK_EDITS_FILTER].values

  const highlightedPathIds = bulkEdit.get('highlightedPathIds')
  const highlightedSiteIds = bulkEdit.get('highlightedSiteIds')
  const visiblePathIds = bulkEdit.get('visiblePathIds')

  // if we're in path mode, just compare the highlighted path list
  // to the visible path list.
  if (bulkMode === 'path') {
    const filteredHighlightedPathIds = highlightedPathIds.filter(d => visiblePathIds.includes(d))

    return dispatch(updateBulkEditState({
      highlightedPathIds: filteredHighlightedPathIds,
    }))
  }

  // we don't need to know if any filter values are applied because getFilteredSegmentEndIds takes care of that for us.
  // all we need to do is compare this returned list against the highlighted and remove any highlighted items
  // which are not found in filteredSegmentEnds
  const filteredSegmentEnds = dispatch(getFilteredSegmentEndIds())

  const filteredHighlightedSiteIds = highlightedSiteIds.filter(d => filteredSegmentEnds.includes(d))

  return dispatch(updateBulkEditState({
    highlightedSiteIds: filteredHighlightedSiteIds,
  }))
}

export default updateHighlighted
